"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import UserPageIdentityAddStatementsContactItems from "./UserPageIdentityAddStatementsContactItems";
import UserPageIdentityAddStatementsContactHeader from "./UserPageIdentityAddStatementsContactHeader";
import { CONTACT_STATEMENT_TYPE, STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import UserPageIdentityAddStatementsForm from "@/components/user/identity/statements/utils/UserPageIdentityAddStatementsForm";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageIdentityAddStatementsContact(t0) {
  const $ = _c(12);
  const {
    profile,
    onClose
  } = t0;
  const [contactType, setContactType] = useState(STATEMENT_TYPE.DISCORD);
  const group = STATEMENT_GROUP.CONTACT;
  let t1;
  if ($[0] !== onClose) {
    t1 = <UserPageIdentityAddStatementsContactHeader onClose={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== contactType) {
    t2 = <UserPageIdentityAddStatementsContactItems activeType={contactType} setContactType={setContactType} />;
    $[2] = contactType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== contactType || $[5] !== onClose || $[6] !== profile) {
    t3 = <UserPageIdentityAddStatementsForm profile={profile} activeType={contactType} group={group} onClose={onClose} />;
    $[4] = contactType;
    $[5] = onClose;
    $[6] = profile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}